<template>
  <ConclusionStep
    data-testid="withdraw-completed-step"
    class="withdraw-completed-step"
    status="positive"
    :title="withdrawConclusion.title"
    :description="withdrawConclusion.subtitle"
    @close="goToProducts"
  >
    <main>
      <ContentDisplay
        content-aspect="outside"
        class="withdraw-completed-step__content"
      >
        <template #content-block-1>
          <Heading class="withdraw-completed-step__product-name" :level="6">
            {{ withdrawConclusion.productName }}
          </Heading>
          <ListDisplay
            v-for="(item, index) in withdrawConclusion.withdrawInfo"
            :key="index"
            class="withdraw-completed-step__list-item"
            :title="item.label"
            :value="item.value"
          />
        </template>
      </ContentDisplay>
    </main>
    <template #button-primary>
      <ButtonPrimary
        label="Voltar para produtos"
        size="large"
        @click="goToProducts"
      />
    </template>
  </ConclusionStep>
</template>

<script setup lang="ts">
import { inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IWithdrawConclusion } from '@/modules/transaction/services/product-withdraw';

const route = useRoute();
const router = useRouter();

const withdrawConclusion = inject(
  'withdrawConclusion'
) as Ref<IWithdrawConclusion>;

function goToProducts() {
  router.push({
    name: 'productsCatalog',
    params: {
      type: route.params.type || 'fixed-income'
    }
  });
}
</script>

<style lang="less" scoped>
.withdraw-completed-step {
  :deep(.flow-conclusion__content) {
    max-width: 492px;
  }

  :deep(.flow-conclusion__details) {
    align-items: initial;
  }

  &__content {
    margin-top: @size-spacing-x500;
    background-color: @background-tertiary;
    border: none;
    padding-bottom: @size-spacing-x500;
  }

  &__product-name {
    margin-bottom: @size-spacing-x500;
  }

  &__list-item {
    margin-bottom: @size-spacing-x350;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
